module.exports = __webpack_public_path__ + "static/media/giftcard.def7d599.svg";